import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Thu Feb 06 2020
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
/**
 * @component BatchLoadingOverlayFrameworkUpdater
 */

var BatchLoadingOverlayFrameworkUpdater =
/*#__PURE__*/
function () {
  /**
   * @param initialCount
   * @param initialTotalCount
   */
  function BatchLoadingOverlayFrameworkUpdater(initialCount, initialTotalCount) {
    _classCallCheck(this, BatchLoadingOverlayFrameworkUpdater);

    this.initialCount = initialCount;
    this.initialTotalCount = initialTotalCount;
    this.count = initialCount || 0;
    this.totalCount = initialTotalCount || undefined;
  }

  _createClass(BatchLoadingOverlayFrameworkUpdater, [{
    key: "setBoth",
    value: function setBoth(count, totalCount) {
      var _this = this;

      runInAction(function () {
        _this.count = count;
        _this.totalCount = totalCount;
      });
    }
  }, {
    key: "setCount",
    value: function setCount(count) {
      var _this2 = this;

      runInAction(function () {
        _this2.count = count;
      });
    }
  }, {
    key: "setTotalCount",
    value: function setTotalCount(totalCount) {
      var _this3 = this;

      runInAction(function () {
        _this3.totalCount = totalCount;
      });
    }
  }, {
    key: "setPreText",
    value: function setPreText(text) {
      var _this4 = this;

      runInAction(function () {
        _this4.preText = text;
      });
    }
  }]);

  return BatchLoadingOverlayFrameworkUpdater;
}();

__decorate([observable, __metadata("design:type", Number)], BatchLoadingOverlayFrameworkUpdater.prototype, "count", void 0);

__decorate([observable, __metadata("design:type", Number)], BatchLoadingOverlayFrameworkUpdater.prototype, "totalCount", void 0);

__decorate([observable, __metadata("design:type", String)], BatchLoadingOverlayFrameworkUpdater.prototype, "preText", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Number, Number]), __metadata("design:returntype", void 0)], BatchLoadingOverlayFrameworkUpdater.prototype, "setBoth", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", void 0)], BatchLoadingOverlayFrameworkUpdater.prototype, "setCount", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Number]), __metadata("design:returntype", void 0)], BatchLoadingOverlayFrameworkUpdater.prototype, "setTotalCount", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], BatchLoadingOverlayFrameworkUpdater.prototype, "setPreText", null);

export default BatchLoadingOverlayFrameworkUpdater;